import axiosHttp from "./interceptor.service";

const postTodoTask = (data) => {
    return axiosHttp.post("/lmt/createTodoTask", data);
};

const getTodoTask = ({
    search,
    sort,
    page,
    limit,
    tab,
    userId,
    userFilter,
    createdByIds,
    assignedToIds,
    startDate,
    endDate,
    status,
    projectId,
    isAdmin,
    priority,
} = {}) => {
    return axiosHttp.get("/lmt/getTodoTask", {
        params: { search, sort, page, limit, tab, userId, userFilter, createdByIds, assignedToIds, startDate, endDate, status, projectId, isAdmin, priority },
    });
};

const getTodoTaskByProjectLeader = ({
    search,
    sort,
    page,
    limit,
    tab,
    userId,
    userFilter,
    createdByIds,
    assignedToIds,
    startDate,
    endDate,
    status,
    projectId,
    isAdmin,
    priority,
} = {}) => {
    return axiosHttp.get("/lmt/getTodoTaskByProjectLeader", {
        params: { search, sort, page, limit, tab, userId, userFilter, createdByIds, assignedToIds, startDate, endDate, status, projectId, isAdmin, priority },
    });
};

const updateTodoTask = (id, data) => {
    return axiosHttp.put(`/lmt/updateTodoTask/${id}`, data);
};

const deleteTodoTask = (id) => {
    return axiosHttp.delete(`/lmt/deleteTodoTask/${id}`);
};

const getTodoTaskHistory = (id) => {
    return axiosHttp.get(`/lmt/getTodoTaskHistory/${id}`);
};

export { postTodoTask, getTodoTask, updateTodoTask, deleteTodoTask, getTodoTaskHistory, getTodoTaskByProjectLeader };
